var CONFUSEDCMS = CONFUSEDCMS || {};

var CONFUSEDCORE = CONFUSEDCORE || {};

(function () {


    CONFUSEDCMS.jQueryValidateExtensions = function (jQuery) {

        //Selector Method Validator
        jQuery.validator.addMethod(
            'selectNone',
            function (value, element) {
                return element.value !== '0';
            },
            'Please select an option.'
        );

        //Regex Method Validator
        jQuery.validator.addMethod(
            'regex',
            function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            },
            'Please check your input.'
        );

        jQuery.validator.addMethod(
            'notdefault',
            function (value, element, param) {
                var $element = jQuery(element);

                if ($element.is('[type=checkbox]')) {
                    return $element.is(':checked');
                }

                if ($element.is('[type=radio]')) {
                    var checkBoxName = $element.attr('name');
                    return $('[name="' + checkBoxName + '"]').is(':checked');
                }

                if (value === param) {
                    return false;
                }

                return true;
            },
            'Please check your input.'
        );

        //Regex Method Validator
        jQuery.validator.addMethod(
            'regextrimmed',
            function (value, element, regexp) {
                var re = new RegExp(regexp);
                value = value.split(' ').join('');
                return this.optional(element) || re.test(value);
            },
            'Please check your input.'
        );
    };

    CONFUSEDCMS.contactUsFormRules = function () {

        function addRule(validator, $form, validationRule) {
            var $elem = $form.find(validationRule.selector);

            if ($elem.length !== 0) {
                if ($elem.attr('data-validationerror')) {
                    //lookup data-errormessage attribute
                    validator.settings.messages[$elem.attr('name')] = $elem.attr('data-validationerror');
                } else if (validationRule.message) {
                    validator.settings.messages[$elem.attr('name')] = validationRule.message;
                }


                $elem.rules('add', validationRule.rules);
            }
        }

        var phoneRequired = function() {
            return (jQuery('input.phone').attr('data-required') === 'true') &&
                jQuery('input.contactByPhoneYes').prop('checked');
        };

        var ValidationDefinition = function (selector, rules, message) {
            this.selector = selector;
            this.rules = rules;
            this.message = message;
        };


        function hookupForm($form, validators, options) {
            if (!$form) {
                throw '$form is undefined!';
            }

            //exit early if form isn't found
            if ($form.length === 0) {
                return;
            }
            options = options || {};

            var validator = $form.validate(options);

            for (var i = 0; i < validators.length; i++) {
                var validationRule = validators[i];
                addRule(validator, $form, validationRule);
            }
        }

        var validationRules = {
            firstName: new ValidationDefinition('input.firstname', {
                notdefault: '',
                required: true,
                regex: '^([a-z]|[A-Z]|[-\']){2,20}$',
                messages: {
                    required: 'Please enter your <b>first name</b>.',
                    regex: 'Please enter a name between 2 and 20 letters long that does not include numbers, commas, or spaces.',
                    notdefault: 'Please enter a name between 2 and 20 letters long that does not include numbers, commas, or spaces.'
                }
            }, 'There is a problem with the first name entered.'),
            surname: new ValidationDefinition('input.surname', {
                notdefault: '',
                required: true,
                regex: '^([a-z]|[A-Z]|[-\'\\ ]){2,30}$',
                messages: {
                    required: 'Please enter your <b>surname</b>.',
                    regex: 'Please enter a name between 2 and 30 letters long that does not include numbers or commas.',
                    notdefault: 'Please enter a name between 2 and 30 letters long that does not include numbers or commas.'
                }
            }, 'There is a problem with the surname entered.'),
            email: new ValidationDefinition('input.email', {
                email: true,
                notdefault: '',
                required: true,
                messages: {
                    email: 'Please enter a valid <b>email address</b>.',
                    required: 'Please enter your <b>email address</b>.',
                    notdefault: 'Please enter your <b>email address</b>.'
                }
            }),
            product: new ValidationDefinition('select.product', {
                selectNone: true,
                required: true
            }, 'Please choose what you’re <b>contacting us</b> about'),
            hasPurchased: new ValidationDefinition('select.haspurchased', {
                selectNone: true,
                required: true
            }, 'Please tell us if you\'ve been successful in purchasing your insurance. If you\'re contacting us about something else, please select \'\Not Applicable\'.'),
            moreinformation: new ValidationDefinition('select#MoreInformation', {
                selectNone: true,
                required: true
            }, 'Please tell us <b>more about your query</b>'),
            title: new ValidationDefinition('select#title', {
                required: true,
                selectNone: true
            }, 'Please select a <b>title</b>.'),
            postcode: new ValidationDefinition('input.postcode', {
                regex: '^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$',
                notdefault: '',
                required: true,
                messages: {
                    required: 'Please enter your <b>postcode</b>.',
                    notdefault: 'Please enter your <b>postcode</b>.',
                    regex: 'Please enter a valid UK <b>postcode</b>.'
                }
            }),
            contactByPhone: new ValidationDefinition('input.contactByPhoneYes', {
                required: true,
                messages: {
                    required: 'Please tell us if we can respond to your query by telephone.'
                }
            }),
            phone: new ValidationDefinition('input.phone', {
                required: phoneRequired,
                regextrimmed: '^\\+?\\d{10,14}$',
                messages: {
                    regextrimmed: 'The <b>phone number</b> you entered is not a valid format.',
                    required: 'Please enter your phone number.'
                }
            }),
            dateOfBirthDay: new ValidationDefinition('select.date-of-birth-day', {
                required: true,
                selectNone: true
            }, 'Please enter the <b>day</b> of your date of birth.'),
            dateOfBirthMonth: new ValidationDefinition('select.date-of-birth-month', {
                required: true,
                selectNone: true
            }, 'Please enter the <b>month</b> of your birth.'),
            dateOfBirthYear: new ValidationDefinition('select.date-of-birth-year', {
                required: true,
                selectNone: true
            }, 'Please enter the <b>year</b> of your birth.'),
            message: new ValidationDefinition('textarea.message', {
                notdefault: '',
                required: true
            }, 'Please enter your <b>message</b>.')

        };

        return {
            hookup: hookupForm,
            validationRules: validationRules
        };

    };

    CONFUSEDCMS.contactUsFormSetup = function (jQuery) {
        CONFUSEDCMS.jQueryValidateExtensions(jQuery);

        var contactUsFormRules = CONFUSEDCMS.contactUsFormRules();
        contactUsFormRules.hookup(jQuery('#frmBody'), [
            contactUsFormRules.validationRules.product,
            contactUsFormRules.validationRules.moreinformation,
            contactUsFormRules.validationRules.email,
            contactUsFormRules.validationRules.title,
            contactUsFormRules.validationRules.firstName,
            contactUsFormRules.validationRules.surname,
            contactUsFormRules.validationRules.hasPurchased,
            contactUsFormRules.validationRules.postcode,
            contactUsFormRules.validationRules.dateOfBirthDay,
            contactUsFormRules.validationRules.dateOfBirthMonth,
            contactUsFormRules.validationRules.dateOfBirthYear,
            contactUsFormRules.validationRules.contactByPhone,
            contactUsFormRules.validationRules.phone,
            contactUsFormRules.validationRules.message
        ],
            {
                errorElement: 'div',
                errorClass: 'error-message',
                errorPlacement: function (error, element) {
                    if (element.parent().find('div.error-placement').length === 0) {
                        element.parent().parent().find('div.error-placement').first().append(error);
                    } else {
                        element.parent().find('div.error-placement').first().append(error);
                    }
                },
                onfocusout: function (element) {
                    var hasNotDefualtClass = jQuery(element).hasClass('notdefault');
                    var elementIsNotCheckable = !this.checkable(element);
                    var elementIsInSubmitted = element.name in this.submitted;
                    var elementIsNotOptional = !this.optional(element);

                    if (hasNotDefualtClass || (elementIsNotCheckable && (elementIsInSubmitted || elementIsNotOptional))) {
                        this.element(element);
                    }
                },
                onkeyup: function (element) {
                    if (jQuery(element).hasClass('notdefault') || (element.name in this.submitted || element === this.lastElement)) {
                        this.element(element);
                    }
                },

                highlight: function (element, errorClass, validClass) {

                    jQuery(element).addClass(errorClass).removeClass(validClass);
                    CONFUSEDCORE.addErrorIndication([jQuery(element).attr('id')]);

                    if (jQuery(element).attr('id') === 'ContactByPhoneYes') {
                        jQuery('input.contactByPhoneNo').addClass('error-message field-error');
                    }
                },

                unhighlight: function (element, errorClass, validClass) {

                    jQuery(element).removeClass(errorClass).addClass(validClass);
                    CONFUSEDCORE.removeErrorIndication([jQuery(element).attr('id')]);

                    if (jQuery(element).attr('id') === 'ContactByPhoneYes') {
                        jQuery('input.contactByPhoneNo').removeClass('error-message field-error');
                    }
                }
            });
        jQuery('input.contactByPhoneYes').on('click', function() {
            jQuery('div.phoneNumberRow').slideDown(200);
        });
        jQuery('input.contactByPhoneNo').on('click', function () {
            jQuery('div.phoneNumberRow').slideUp(200);
            jQuery('input.phone').valid();
        });
    };

})();